import { render, staticRenderFns } from "./ChooseSeats.vue?vue&type=template&id=7ac9825a&"
import script from "./ChooseSeats.vue?vue&type=script&lang=js&"
export * from "./ChooseSeats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports